<div style="padding: 20px;">
  <!-- Action Buttons -->
  <div style="text-align: right; margin-bottom: 20px;">
    <button id="print-button" class="noPrint btn btn-primary" style="display: none;"
      mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>

    <button class="noPrint btn btn-primary" (click)="print()" mat-raised-button color="primary">
      Print
    </button>

    <button class="noPrint btn btn-primary" (click)="exportExcel('issue_seller_Invoice_Register')" mat-raised-button color="primary">
      Export
    </button>

    <button class="noPrint btn btn-secondary" mat-button mat-dialog-close>
      Close
    </button>
  </div>

  <!-- Main Report Section -->
  <div class="container" id="print-section1">
    <ng-container *ngIf="indetail && !datewise && !officerep">
      <table class="table table-bordered table-sm">
        <thead class="thead-light">
          <tr>
            <th colspan="3">Vivek Saptahik</th>
            <th colspan="5">Issue Seller Repwise Indetail. Registration Report</th>
            <th colspan="2">In Detail</th>
            <th colspan="5">Date: {{ today | date:"dd-MM-yyyy" }}</th>
            <th colspan="3">Page No</th>
          </tr>
          <tr>
            <th colspan="3">Date From: {{ start_date | date:"dd-MM-yyyy" }}</th>
            <th colspan="2">To: {{ end_date | date:"dd-MM-yyyy" }}</th>
            <th colspan="3">Issue/Grantha Category: {{ issue_cat }}</th>
            <th colspan="2">Issue Date: {{ issueDate | date:"dd-MM-yyyy" }}</th>
            <th colspan="5">Issue Name: {{ issue_name }}</th>
            <th colspan="3"></th>
          </tr>
          <tr>
            <th>Sr.<br />No</th>
            <th>Booking<br />Date</th>
            <th>Booking<br />No</th>
            <th colspan="2">Issue Seller Name</th>
            <th>Representative<br />Name</th>
            <th>Office<br />Rep. Name</th>
            <th>RO Number<br />Instruction</th>
            <th>Issue Copies</th>
            <th>Issue<br />Amt.</th>
            <th>Net<br />Amt.</th>
            <th>GST 5%</th>
            <th>Total<br />Amt.</th>
            <th>Received<br />Amt.</th>
            <th>Receipt No.<br />and Date</th>
            <th>Pending<br />Amt.</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let item of inDetailsRegReport1; let i = index">
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ item.booking_date }}</td>
              <td>{{ item.booking_no }}</td>
              <td colspan="2">{{ item.issue_seller_name }}</td>
              <td>{{ item.rep_name }}</td>
              <td>{{ item.off_rep_name }}</td>
              <td>{{ item.ro_no }}</td>
              <td>{{ item.advtsize }}</td>
              <td class="text-end">{{ item.issue_seller_amt }}</td>
              <td class="text-end">{{ item.amount }}</td>
              <td class="text-end">{{ toInt(item.sgst) + toInt(item.cgst) }}</td>
              <td class="text-end">{{ item.igst }}</td>
              <td class="text-end">{{ item.part_pymt_amt }}</td>
              <td>
                {{ item.rep_rcpt_no }}
                <ng-container *ngIf="item.rcpt_date != '0000-00-00'">
                  <br />{{ item.rcpt_date | date:"dd-MM-yyyy" }}
                </ng-container>
              </td>
              <td class="text-end">{{ item.part_pymt_remaning_amt }}</td>
            </tr>
          </ng-container>

          <!-- Total Row -->
          <tr class="fw-bold">
            <td></td>
            <td colspan="4">Total No of Advt: {{ inDetailsRegReportTotal.total_advt }}</td>
            <td colspan="4"></td>
            <td class="text-end">{{ inDetailsRegReportTotal.advt_total }}</td>
            <td class="text-end">{{ inDetailsRegReportTotal.net_amt }}</td>
            <td class="text-end">{{ inDetailsRegReportTotal.gst }}</td>
            <td class="text-end">{{ inDetailsRegReportTotal.total_amt }}</td>
            <td class="text-end">{{ inDetailsRegReportTotal.rcvd_amt }}</td>
            <td></td>
            <td class="text-end">{{ inDetailsRegReportTotal.pndg_amt }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>

  <!-- Representative In Detail Section -->
  <div class="container" *ngIf="type === 'Represantative Indetails'">
    <div id="print-section" style="margin-top: 20px; ">
      <table class="table table-bordered table-sm">
        <thead class="thead-light">
          <tr>
            <th colspan="2" style="font-weight: bold">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
            <th colspan="3"style="font-weight: bold">अंकाचे नाव: {{ newissuedatepp }}</th>
            <th colspan="4"style="font-weight: bold">Issue/Grantha Register Report - In Details Representative</th>
            <th colspan="4"style="font-weight: bold">Date: From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date: 'dd-MM-yyyy' }}</th>
            <th colspan="4"style="font-weight: bold">पृष्ठ क्र : 1</th>
          </tr>
          <tr>
            <th colspan="2"style="font-weight: bold">Issue/Grantha Category</th>
            <th colspan="1"style="font-weight: bold">{{categoryNameForHTML}}</th>
            <th colspan="2"style="font-weight: bold"></th>
            <th colspan="3"style="font-weight: bold">Issue Name</th>
            <th colspan="7"style="font-weight: bold">{{issueNameForHTML}}</th>
          </tr>
          <tr>
            <th tyle="font-weight: bold">Sr</th>
            <th style="font-weight: bold">Booking Date</th>
            <th style="font-weight: bold">Booking No</th>
            <th style="font-weight: bold">Seller Name</th>
            <th style="font-weight: bold">Representative Name</th>
            <th style="font-weight: bold">Mobile Number</th>
            <th style="font-weight: bold">Office Rep Name</th>
            <th class="text-end"style="font-weight: bold">Price</th>
            <th class="text-end" style="font-weight: bold">No. Of Copies</th>
            <th class="text-end" style="font-weight: bold">Total Amount</th>
            <th class="text-end" style="font-weight: bold">Disc Amt</th>
            <th class="text-end" style="font-weight: bold">Net Amt</th>
            <th class="text-end" style="font-weight: bold">जमा बाकी</th>
            <th class="text-end" style="font-weight: bold">येणे बाकी</th>
          </tr>
        </thead>

     <tbody *ngFor="let report of filteredinDetailsRegReport; let reportIndex = index">
  <!-- Representative Header Row -->
  <tr>
    <td colspan="14" class="fw-bold">Representative: {{ report.rep_name }} ({{ reportIndex + 1 }})</td>
  </tr>

  <!-- Data Rows -->
  <tr *ngFor="let item of report.issue_data; let itemIndex = index">
    <td>{{ itemIndex + 1 }}</td>
    <td class="text-end">{{ item.booking_date | date: "dd-MM-yyyy" }}</td>
    <td class="text-end">{{ item.booking_no }}</td>
    <td class="text-end">{{ item.issue_seller_name }}</td>
    <td class="text-end">{{ report.rep_name }}</td>
    <td class="text-end">{{ report.rep_mob_no }}</td>
    <td class="text-end">{{ item.off_rep_name }}</td>
    <td class="text-end">{{ item.issue_seller_price }}</td>
    <td class="text-end">{{ item.issue_copies }}</td>
    <td class="text-end">{{ item.issue_seller_amt }}</td>
    <td class="text-end">{{ item.issue_seller_discount }}</td>
    <td class="text-end">{{ item.net_amount }}</td>
    <td class="text-end">{{ item.entry_amt | number: '1.2-2' }}</td>
    <td class="text-end">{{ item.net_amount - item.entry_amt }}</td>
  </tr>

  <!-- Totals Row -->
  <tr class="fw-bold">
    <td colspan="8" class="text-end">Total:</td>
    <td class="text-end">{{ getRepresentativeTotals(report.issue_data, 'issue_copies') }}</td>
    <td class="text-end">{{ getRepresentativeTotals(report.issue_data, 'issue_seller_amt') | number: '1.2-2' }}</td>
   <td class="text-end">{{ getRepresentativeTotals(report.issue_data, 'issue_seller_discount') | number: '1.2-2' }}</td>
    <td class="text-end">{{ getRepresentativeTotals(report.issue_data, 'net_amount') | number: '1.2-2' }}</td>
    <td class="text-end">{{ getRepresentativeTotals(report.issue_data, 'entry_amt') | number: '1.2-2' }}</td>
    <td class="text-end">
      {{
        (getRepresentativeTotals(report.issue_data, 'net_amount') - getRepresentativeTotals(report.issue_data, 'entry_amt'))
        | number: '1.2-2'
      }}
    </td>
  </tr>
</tbody>

        

        <!-- Total Footer -->
        <tfoot>
          <tr class="fw-bold">
            <td colspan="7" class="text-center">एकूण</td>
            <td class="text-end">{{totalAmounts.issue_seller_price | number: '1.2-2' }}</td>
            <td class="text-end">{{ totalAmounts.issue_seller_copies | number: '1.2-2' }}</td>
            <td class="text-end">{{ totalAmounts.total_amount | number: '1.2-2' }}</td>
            <td class="text-end">{{ totalAmounts.issue_selling_discount_amt | number: '1.2-2' }}</td>
            <td class="text-end">{{ totalAmounts.net_amount | number: '1.2-2' }}</td>
            <td class="text-end">{{ totalAmounts.rcvamount| number: '1.2-2' }}</td>
            <td class="text-end">{{ (totalAmounts.net_amount - totalAmounts.rcvamount) | number: '1.2-2' }}</td>
           
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>

<!-- Loading Indicator -->
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>
